import React from 'react';
import Banner from '../components/platform/platformPageLayout';
class PlatformPage extends React.Component {
	render() {
		return <Banner/>;
	}
}

export default PlatformPage;